var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('activate-message',{staticClass:"regist-inrormation-complete",scopedSlots:_vm._u([{key:"pageTitle",fn:function(){return [_vm._v("メールアドレス登録完了")]},proxy:true},{key:"description",fn:function(){return [_c('p',[_vm._v("認証メールを送信しました。")]),_c('p',[_vm._v("しばらく待ってもメールが届かない場合、登録をやり直してください。")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }